import { IAttributeFilterState, IFilter, IRootState } from '@/store/types/IRootState';
import { isNameFilter } from '@/store/isNameFilter';
import { FilterType } from './FilterMutations';

const MaxAttributeFilterCount = 10;

const attributeFilterMutations = {
    cleanAttributeFilters(state: IRootState, { preserveNameFilters }: ICleanAttributeFiltersOptions) {
        state.attributeFilters = preserveNameFilters
            ? state.attributeFilters.filter(filter => isNameFilter(filter.name))
            : [];
    },

    addCustomAttributeFilter(state: IRootState, params: { subFilterIndex: number, customFilter: string }) {
        state.attributeFilters[params.subFilterIndex].customFilter.
            value = params.customFilter.toUpperCase();
    },

    populateAttributeFilters(state: IRootState, newFilters: any) {
        // state.attributeFilters já foi 'limpo' aqui com cleanAttributeFilters
        state.attributeFilters = state.attributeFilters.concat(
            newFilters
                .map((attr: any) => {
                    const attrName = Object.keys(attr)[0];

                    const filters = attr[attrName]
                        .map((filter: any) => ({
                            name: attrName,
                            checked: false,
                            value: Object.keys(filter)[0],
                            count: filter[Object.keys(filter)[0]],
                            type: FilterType.Atributos,
                        } as IFilter));

                    return {
                        name: attrName,
                        count: filters.reduce((total: number, { count }: IFilter) => total + count, 0),
                        customFilter: { name: '', value: '' },
                        showAllFilters: true,
                        showFilterGroup: true,
                        filters,
                    } as IAttributeFilterState;
                })
                .filter((attr: IAttributeFilterState) => !state.attributeFilters.some(a => a.name === attr.name))
                .sort((a: IAttributeFilterState, b: IAttributeFilterState) => b.count - a.count),
        )
            .slice(0, MaxAttributeFilterCount)
            ;
    },

    toggleShowAllAttributeFiltersFlag(state: any, attributeFilterName: string) {
        const attributeFound = state.attributeFilters.find((attributeFilter: IAttributeFilterState) => attributeFilter.name === attributeFilterName);
        attributeFound.showAllFilters = !attributeFound.showAllFilters;
    },

    toggleShowFilterGroupAttributeFlag(state: any, attributeFilterName: string) {
        const attributeFound = state.attributeFilters.find((attributeFilter: IAttributeFilterState) => attributeFilter.name === attributeFilterName);
        attributeFound.showFilterGroup = !attributeFound.showFilterGroup;

    },

};

interface ICleanAttributeFiltersOptions {
    preserveNameFilters: boolean;
}

export default attributeFilterMutations;
